<!-- 收集试用报告 -->
<template>
  <div class="content">
    <span v-if="isShowAddBtn">
      <el-button @click="openQuestion" v-if="!isReadOnly && !isStart"
        >添加题目</el-button
      >
      <el-button disabled v-else>添加题目</el-button>
      （{{ form.length }}/{{ limitNum }}）
    </span>

    <el-table
      v-if="form.length > 0"
      :data="form"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
      border
      style="width: 100%;margin-top: 12px;"
    >
      <el-table-column
        label="排序"
        width="100"
        header-align="left"
        v-if="isShowAddBtn"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="题目类型" width="100">
        <template slot-scope="scope">
          {{ questionType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="是否必填" width="100">
        <template slot-scope="scope">
          {{ questionRequire(scope.row.isMust) }}
        </template>
      </el-table-column>
      <el-table-column label="题目名称（50个字以内）" width="360">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="题目内容" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.type <= 2">
            <div
              v-for="(item, index) in getNowOption(
                scope.row.options,
                scope.$index
              )"
              :key="item.id"
              class="option-text"
            >
              {{ optionTitle(index) }}.{{ item.description }}
            </div>
            <el-button
              v-if="scope.row.options && scope.row.options.length > 3"
              type="text"
              class="action-btn"
              @click="showAllOptions(scope.row, scope.$index)"
            >
              {{ "查看全部" }}
            </el-button>
          </div>
          <div v-else-if="scope.row.type == 3">
            请输入内容，不少于{{ scope.row.textLimit }}个字
          </div>
          <div v-else-if="scope.row.type == 4 || scope.row.type == 5">
            <div
              class="m_image"
              v-for="(item, index) in scope.row.options"
              :key="item.id"
            >
              {{ optionTitle(index) }}.
              <img :src="item.picUrl" alt="" />
            </div>
          </div>
          <div v-else-if="scope.row.type == 6">
            上传不少于{{ scope.row.picLimit }}张，最多 5张图片
          </div>
          <div v-else-if="scope.row.type == 7">
            <div v-for="item in getRowDes(scope.row.options)" :key="item.id">
              {{ item.rowDescription }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="action-btn"
            @click="editQuestion(scope.row, scope.$index)"
            v-if="!isReadOnly && !isStart"
            :disabled="!(!isReadOnly && !isStart)"
            >{{ actionText }}</el-button
          >
          <el-button
            type="text"
            class="action-btn"
            @click="deleteQuestion(scope.$index)"
            v-if="isShowAddBtn && !isReadOnly && !isStart"
            :disabled="!(!isReadOnly && !isStart)"
            >删除</el-button
          >
          <el-button
            type="text"
            class="action-btn"
            @click="upSet(scope.$index)"
            v-if="scope.$index !== 0 && !isReadOnly && !isStart"
            :disabled="scope.$index == 0"
            >上移</el-button
          >
          <el-button
            type="text"
            class="action-btn"
            @click="downSet(scope.$index)"
            v-if="scope.$index !== form.length - 1 && !isReadOnly && !isStart"
            :disabled="scope.$index == form.length - 1"
            >下移</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <addQuestion
      :visible.sync="isDialogVisible"
      :isEdit="question.isEdit"
      :onlyShow="question.onlyShow"
      :currentQuestion="question.currentQuestion"
      @reset-only-show="resetOnlyShow"
      @confirm="handleConfirm"
      @close="handleClose"
    ></addQuestion>
  </div>
</template>

<script>
// 参考收集使用报告组件写的
import addQuestion from "./addTopic.vue";
export default {
  components: {
    addQuestion,
  },
  props: {
    // 回显的数据
    questions: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      // 只读
      type: Boolean,
      default: false,
    },
    isStart: {
      // 活动是否在进行中
      type: Boolean,
      default: false,
    },
    labelWidth: {
      // 表单label宽度
      type: String,
      default: "80px",
    },
    labelName: {
      // 表单label名称
      type: String,
      default: "设置题目",
    },
    limitNum: {
      type: Number,
      default: 30,
    },
    // 控制添加按钮显示
    isShowAddBtn: {
      type: Boolean,
      default: true,
    },
    actionText: {
      type: String,
      default: "修改",
    },
  },
  mounted() {
    if (this.questions.length > 0) {
      this.form = JSON.parse(JSON.stringify(this.questions));
      console.log("---  this.questions:---", this.questions);
    }
  },
  watch: {
    questions: {
      handler(val) {
        if (val.length > 0) {
          this.form = JSON.parse(JSON.stringify(val));
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      isDialogVisible: false, // 控制弹窗显示/隐藏
      question: {
        // 回显的数据
        index: null, // 回显的数据下标
        isEdit: false, // 是否在编辑状态
        onlyShow: false, // 仅查看
        currentQuestion: {}, // 回显的问题
      },
      // 表单数据
      form: [],
    };
  },
  methods: {
    // 下移
    downSet(index) {
      if (index < this.form.length - 1) {
        const temp = this.form[index];
        this.form.splice(index, 1, this.form[index + 1]);
        this.form.splice(index + 1, 1, temp);
        this.$emit("collectQuestion", this.form);
      }
    },
    // 上移
    upSet(index) {
      if (index !== 0) {
        const temp = this.form[index];
        this.form.splice(index, 1, this.form[index - 1]);
        this.form.splice(index - 1, 1, temp);
        this.$emit("collectQuestion", this.form);
      }
    },
    // 修改题目
    editQuestion(item, index) {
      this.question.currentQuestion = item;
      this.question.index = index;
      this.question.isEdit = true;
      this.isDialogVisible = true;
    },
    // 删除题目
    deleteQuestion(index) {
      this.form.splice(index, 1);
      this.$emit("collectQuestion", this.form);
      // console.log("--- this.form:---", this.form)
    },
    // 打开添加题目弹窗
    openQuestion() {
      if (this.form.length >= this.limitNum) {
        this.$message.warning(`最多只能添加${this.limitNum}个题目`);
        return;
      }
      this.isDialogVisible = true;
    },
    // 题目类型
    questionType(type) {
      const typeMap = {
        1: "单选题",
        2: "多选题",
        3: "填空题",
        4: "图片单选题",
        5: "图片多选题",
        6: "图片上传题",
        7: "矩阵题",
      };
      return typeMap[type] || "";
    },
    // 是否必填
    questionRequire(val) {
      if (val.toString() == "0") {
        return "否";
      } else if (val.toString() == "1") {
        return "是";
      }
    },
    // 根据 index获取选项名称
    optionTitle(index) {
      switch (index) {
        case 0:
          return "A";
        case 1:
          return "B";
        case 2:
          return "C";
        case 3:
          return "D";
        case 4:
          return "E";
        case 5:
          return "F";
        case 6:
          return "G";
        case 7:
          return "H";
        case 8:
          return "I";
        case 9:
          return "J";
        case 10:
          return "K";
        case 11:
          return "L";
        case 12:
          return "M";
        case 13:
          return "N";
        case 14:
          return "O";
        case 15:
          return "P";
        case 16:
          return "Q";
        case 17:
          return "R";
        case 18:
          return "S";
        case 19:
          return "T";
        default:
          return "";
      }
    },
    // 确认操作
    handleConfirm(data) {
      let index = this.question.index;
      if (this.question.isEdit) {
        // 修改题目
        this.form.splice(index, 1, data);
      } else {
        // 新增题目
        this.form.push(data);
        console.log("---  this.form:---", this.form);
      }
      this.question.isEdit = false;
      this.$emit("collectQuestion", this.form);
    },
    // 关闭弹窗
    handleClose() {
      console.log("弹窗已关闭");
      this.question.isEdit = false;
    },

    getRowDes(options) {
      let options10Row = [];
      options.forEach((item) => {
        let options10RowSort = options10Row.map((item1) => item1.sort);
        if (!options10RowSort.includes(item.sort)) {
          let rowObj = {
            rowDescription: item.description.split(":")[0],
            ...item,
          };
          options10Row.push(rowObj);
        }
      });
      options10Row.sort(function(a, b) {
        return a.sort - b.sort;
      });
      return options10Row;
    },
    // 获取当前的选项(超过三条进行截取, 点击了展开则显示全部)
    getNowOption(options) {
      if (options && options.length > 3) {
        return options.slice(0, 3);
      }
      return options;
    },
    // 点击查看全部
    showAllOptions(item, index) {
      this.question.currentQuestion = item;
      this.question.index = index;
      this.question.onlyShow = true;
      this.isDialogVisible = true;
    },
    // 重置查看变量
    resetOnlyShow() {
      this.question.onlyShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  // background-color: #f8f9fc;
  width: 1055px;
  // padding: 20px 0px 20px 24px;
  color: #666666;
  font-size: 14px;

  .flex-1 {
    flex: 1;
  }

  .flex-4 {
    flex: 4;
  }

  .flex-2 {
    flex: 2;
  }

  .h_sort,
  .m_sort {
    padding-left: 34px;
  }

  .questions {
    width: calc(100% - 8px);
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    margin-right: 8px;
    margin-top: 10px;

    .q_head {
      width: 100%;
      background-color: #f0f2f7;
      display: flex;
      align-items: center;
      height: 48px;
    }

    .multiple {
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      padding: 14px 0;

      .m_title {
        .m_text {
          width: 80%;
          line-height: 20px;
        }
      }

      .m_content {
        display: flex;
        flex-direction: column;

        div {
          line-height: 20px;
        }
      }

      .m_operate {
        display: flex;
        align-items: center;
        color: #3158ff;
        gap: 10px;

        span {
          cursor: pointer;
        }

        .disabled {
          color: #c0c4cc;
          cursor: not-allowed;
        }
      }
    }
  }
}

.fill_text {
  width: 80%;
}

.m_image {
  display: flex;
  align-items: center;
  margin-top: 8px;

  img {
    width: 32px;
    height: 32px;
  }
}

.m_image:nth-child(1) {
  margin-top: 0px;
}
/deep/ .el-table .el-table__header-wrapper th .cell {
  text-align: left !important;
  font-weight: 500;
}

.option-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  max-height: 2.8em;
  margin-bottom: 5px;
}
.action-btn {
  width: auto;
  padding: 0 !important;
}
</style>
